<div class="image-modal-preview" [class.in-iframe]="inIframe" *ngIf="imageSrc && show" tabindex="0"
  (keydown.esc)="closeFullScreen()" #imageModalPreview (keydown.arrowleft)="navigatePrevious()"
  (keydown.arrowright)="navigateNext()">

  <span class="close" [attr.title]="'FullScreen_Close' | NTSTranslate" (click)="closeFullScreen()" tabindex="0"
    (keydown.esc)="closeFullScreen()">
    <svg-icon key="cancel"></svg-icon>
  </span>
  <span class="download" *ngIf="showDownloadButton" [attr.title]="'FullScreen_Download' | NTSTranslate"
    (click)="downloadFileFromFullscreen()" tabindex="0" (keydown.esc)="closeFullScreen()">
    <svg-icon key="download"></svg-icon>
  </span>

  <img class="modal-content" [attr.src]="imageSrc">

  <span class="previous" *ngIf="canNavigate" [attr.title]="'FullScreen_Previous' | NTSTranslate"
    (click)="navigatePrevious()" tabindex="0" (keydown.esc)="closeFullScreen()">
    <svg-icon key="arrow-back"></svg-icon>
  </span>
  <span class="next" *ngIf="canNavigate" [attr.title]="'FullScreen_Next' | NTSTranslate"
    (click)="navigateNext()" tabindex="0" (keydown.esc)="closeFullScreen()">
    <svg-icon key="arrow-forward"></svg-icon>
  </span>

</div>
